import { Icon } from '@iconify/react/dist/iconify.js'
import React from 'react'

function Maintenance() {
  return (
    <div className='flex flex-col justify-center items-center h-lvh'>
        <div className='flex justify-center w-full'><img src="https://cdni.iconscout.com/illustration/premium/thumb/website-under-development-4412399-3658846.png" alt="" /></div>
        <div className='flex justify-center flex-row gap-2 items-center'>
        <Icon icon="carbon:license-maintenance-draft" className='text-2xl text-gray-700'/>
            <h4 className='text-2xl text-gray-700 '>Website under maintenance. </h4>
            <h4 className='text-2xl text-gray-700'> we will be back in very soon...</h4>
        </div>

        <div className='flex justify-center '>
        <h6 className='text-gray-700'> contact admin at <span className='text-blue-500 cursor-pointer'>admin@kla.com</span></h6>
        </div>
    </div>
  )
}

export default Maintenance